/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {IconProps} from '../../types/types';
import useIconDLS from '../useIconDLS';

/*
 * Defines the Design Language System (DLS) Urgent Icon component.
 */
export const UrgentIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <svg width={iconSize} height={iconSize} viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M8.43002 2.08611C8.23767 1.75197 7.75548 1.75206 7.56326 2.08629L1.09743 13.3287C0.905725 13.662 1.14633 14.078 1.53086 14.078H14.4684C14.853 14.078 15.0936 13.6619 14.9017 13.3285L8.43002 2.08611Z' stroke='#E2231A' strokeMiterlimit='10' />
      <path d='M7.99512 5.76074V10.0135' stroke={iconColor} strokeMiterlimit='10' />
      <path d='M7.99512 10.7793V11.955' stroke={iconColor} strokeMiterlimit='10' />
    </svg>
  );
};

export default UrgentIcon;
